import { merge } from '@asset-solutions/shared/utilities';

/**
 * Parses strings from a properties file into usable JSON.
 * @example
 * Converts the following properties:
 * ```json
 * {
 *   "featureFlags.liveMap": "true",
 *   "featureFlags.tractors": "true"
 * }
 * ```
 * to the following object:
 * ```json
 * {
 *   "featureFlags": {
 *     "liveMap": true,
 *     "tractors": true
 *   }
 * }
 * ```
 */
export const parseConfig = <T extends Record<string, any>>(properties: Record<string, string>): T => {
  return Object.keys(properties).reduce((acc, key) => {
    let value;

    try {
      value = JSON.parse(properties[key]);
    } catch (_) {
      value = properties[key];
    }

    // Convert path and value into JSON string.
    if (typeof value === 'string') {
      value = `"${value}"`;
    }
    const pathArray = key.split('.');
    const jsonString = `{"${pathArray.join('":{"')}":${value}${pathArray.map(() => '}').join('')}`;

    acc = merge(acc, JSON.parse(jsonString));
    return acc;
  }, {} as T);
};
